import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import TeacherNavbar from "./TeacherNavbar";
import Footer from "../../../components/Footer";
import Header2 from "../../../components/Header2";
import { useDispatch } from "react-redux";
import { fetchTeacherDetails } from "../../SchoolModule/teachers/redux/teacherSlice";

const TeacherPlannerLayout = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchTeacherDetails());
  }, [dispatch]);
  return (
    <div className="container-fluid vh-100 d-flex flex-column p-0">
      {/* <Header2 /> */}

      <div className="row flex-grow-1 m-0 overflow-hidden">
        <div className="col-12 p-0 d-flex flex-column h-100">
          <TeacherNavbar />
          <div
            className="flex-grow-1 overflow-hidden d-flex"
            style={{
              position: "relative",
              background:
                "linear-gradient(to bottom, #ffffff 40%, #B9D9F0 100%)",
            }}
          >
            <div
              style={{
                content: "''",
                backgroundImage: `url('/images/schoold-home-banner.png')`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundSize: "50%",
                opacity: 0.15,
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 0,
              }}
            />
            <div
              className="overflow-auto w-100 py-3 px-5"
              style={{
                zIndex: 1,
                position: "relative",
              }}
            >
              <Outlet />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default TeacherPlannerLayout;
